export const UPDATE_GUIDELINE_GPT_USAGE = "UPDATE_GUIDELINE_GPT_USAGE";
export const UPDATE_SCENARIO_DESK_USAGE = "UPDATE_SCENARIO_DESK_USAGE";
export const UPDATE_MISMO_USAGE = "UPDATE_MISMO_USAGE";
export const UPDATE_FORM1003_USAGE = "UPDATE_FORM1003_USAGE";
export const SET_DEFAULT_USE = 'SET_DEFAULT_USE';